<div class="insurance-section" *transloco="let t; prefix: 'accidents.modals.insuranceClaim'">
  <h4 class="section-title">{{ t('title') }}</h4>

  <form [formGroup]="claimForm" class="insurance-form">
    <div class="form-row">
      <div class="form-group">
        <label for="insuranceCompany" class="form-label">{{ t('insuranceCompany') }} <span class="required">*</span></label>
        <input
          type="text"
          id="insuranceCompany"
          formControlName="insuranceCompany"
          class="form-control"
          [placeholder]="t('insuranceCompanyPlaceholder')">
      </div>

      <div class="form-group">
        <label for="policyNumber" class="form-label">{{ t('policyNumber') }} <span class="required">*</span></label>
        <input
          type="text"
          id="policyNumber"
          formControlName="policyNumber"
          class="form-control"
          [placeholder]="t('policyNumberPlaceholder')">
      </div>
    </div>

    <div class="form-group">
      <label class="form-label">{{ t('severity') }} <span class="required">*</span></label>
      <div ngbDropdown class="dropdown-wrapper" [autoClose]="true">
        <button type="button" class="form-control dropdown-toggle" ngbDropdownToggle>
          <div class="dropdown-inner">
            <span>{{ severityLabel }}</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.862 6.19531L7.99998 9.05731L5.13798 6.19531L4.19531 7.13798L7.99998 10.9426L11.8046 7.13798L10.862 6.19531Z" fill="#9FA1A4"/>
            </svg>
          </div>
        </button>
        <div ngbDropdownMenu class="dropdown-menu">
          @for (severity of severities; track severity) {
            <button type="button" class="dropdown-item" (click)="onSeveritySelect(severity)" ngbDropdownItem>
              {{ severityLabelKeys[severity] | transloco }}
            </button>
          }
        </div>
      </div>
    </div>

    <div class="form-group">
      <label for="incidentDescription" class="form-label">{{ t('incidentDescription') }}</label>
      <textarea
        id="incidentDescription"
        formControlName="incidentDescription"
        class="form-control form-textarea"
        rows="4"
        [placeholder]="t('descriptionPlaceholder')"></textarea>
    </div>
  </form>
</div>

<!-- Footer Actions -->
<div class="insurance-claim-tab__actions">
  <button type="button" class="btn-cancel" (click)="onCancel()">
    <span>{{ 'common.cancel' | transloco }}</span>
  </button>
  <button type="button" class="btn-save" [disabled]="!isFormValid || isSubmitting || !areDocumentsReady" (click)="onSave()">
    <span>{{ 'accidents.modals.insuranceClaim.fileInsuranceClaim' | transloco }}</span>
  </button>
</div>